import { useState } from "react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { PaymentMethodSummary } from "@/components/counting/PaymentMethodSummary";
import { Card } from "@/components/ui/card";
import { usePaymentSummaries } from "@/hooks/usePaymentSummaries";
import { DiscrepancyManager } from "@/components/counting/DiscrepancyManager";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PaymentSummary } from "@/components/counting/types/PaymentTypes";
import { FinancingTab } from "@/components/counting/tabs/FinancingTab";

const Counting = () => {
  const [period, setPeriod] = useState("day");
  const [countedAmounts, setCountedAmounts] = useState<Record<string, number>>({});
  const { summaries, isLoading } = usePaymentSummaries(period);

  const handleCountedChange = (method: string, value: string) => {
    setCountedAmounts((prev) => ({
      ...prev,
      [method]: value ? parseFloat(value) : undefined,
    }));
  };

  const summariesWithCounted: PaymentSummary[] = summaries.map(summary => ({
    ...summary,
    counted: countedAmounts[summary.method],
  }));

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <PageTitle
          title="Comptage du stock"
        />

        <Tabs defaultValue="counting" className="space-y-6">
          <TabsList>
            <TabsTrigger value="counting">Comptage</TabsTrigger>
            <TabsTrigger value="discrepancies">Différences</TabsTrigger>
            <TabsTrigger value="financing">Déja Comptés</TabsTrigger>
          </TabsList>

          <TabsContent value="counting">
            <div className="space-y-6">
              <Card className="p-6">
                <PaymentMethodSummary
                  summaries={summariesWithCounted}
                  onCountedChange={handleCountedChange}
                  period={period}
                />
              </Card>
            </div>
          </TabsContent>

          <TabsContent value="discrepancies">
            <DiscrepancyManager />
          </TabsContent>

          <TabsContent value="financing">
            <FinancingTab />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};

export default Counting;